export const formatCOP = (cents: number | null | undefined): string => {
  if (cents == null) return '—';
  return (cents / 100).toLocaleString('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

/**
 * Parsea un string con formato COP ("15.000", "15000", "$15.000") a
 * centavos. Útil para el form de productos donde el usuario escribe en
 * pesos pero el backend trabaja en centavos.
 */
export const parseCOPToCents = (value: string): number => {
  const digits = value.replace(/[^\d-]/g, '');
  if (digits.length === 0) return 0;
  return Math.round(Number(digits) * 100);
};
